import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { ENABLE_NATURAL_LANGUAGE_SEARCH_MVP_250501 } from "@faire/web-api--source/indigofair/settings/ENABLE_NATURAL_LANGUAGE_SEARCH_MVP_250501";

export const useSettingEnableNLSSearch = (): boolean => {
  const isSettingEnabled = useSetting(
    ENABLE_NATURAL_LANGUAGE_SEARCH_MVP_250501,
    false
  );
  const isLoggedInRetailer = useIsLoggedInRetailer();
  return isSettingEnabled && isLoggedInRetailer;
};
